import { useState } from "react";
import { trackEvent } from "./analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

export const useMenuDrawer = () => {
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    trackEvent(
      EventCategory.NavigationMenu,
      "Opened Menu",
      window.location.href,
    );
    setOpen(true);
  };

  const handleDrawerClose = () => {
    trackEvent(
      EventCategory.NavigationMenu,
      "Closed Menu",
      window.location.href,
    );
    setOpen(false);
  };

  return {
    open,
    handleDrawerOpen,
    handleDrawerClose,
  };
};
